import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { ToggleButton, EditIcon } from 'wix-rich-content-toolbars-ui';

const AudioEditButton = ({ toolbarItem, dataHook }) => {
  const { isMobile, t } = useContext(RicosContext) || {};
  const onClick = toolbarItem.commands.click;
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      dataHook,
      Icon: EditIcon,
      label: t("AudioPlugin_Toolbar_Edit_Label"),
      tooltip: t("AudioPlugin_Toolbar_Edit_Label"),
      onClick: () => onClick({ isMobile })
    }
  );
};

export { AudioEditButton as default };
//# sourceMappingURL=AudioEditButton.js.map
